import type { FC } from 'react';
import cn from 'classnames';

import styles from './Separator.module.scss';

interface ISeparator {
  className?: string;
}

const Separator: FC<ISeparator> = ({ className }) => <hr className={cn(styles.separator, className)} />;

export default Separator;
